import { bootstrapApplication } from '@angular/platform-browser';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

import 'hammerjs';

import { RuntimeConfigService } from './app/services/app/runtime-config.service';
import { installPrimengSelectPanelWidthPatch } from './app/core/config/primeng-select-panel-width';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

installPrimengSelectPanelWidthPatch();

const configService = new RuntimeConfigService();
configService.initializeConfig().then(() => {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
});
